// Types for user agnostic feature gates

/**
 * Configuration registry for user agnostic feature gates
 * Maps Statsig gate names to their default values
 */
export const FEATURE_GATE_REGISTRY = {
  ssr_telemetry_attentive: true,
  ssr_telemetry_claritas: true,
  ssr_telemetry_criteoanalytics: true,
  ssr_telemetry_fb_pixel: true,
  ssr_telemetry_google_analytics: true,
  ssr_telemetry_google_analytics_4: true,
  ssr_telemetry_google_ads_tag: true,
  ssr_telemetry_google_web_container: true,
  ssr_telemetry_internal_analytics: true,
  ssr_telemetry_impact: true,
  'ssr_telemetry_linked_in-pixel': true,
  ssr_telemetry_pebble_post: true,
  ssr_telemetry_poplar: true,
  ssr_telemetry_pinterest_tag: true,
  ssr_telemetry_retention_tracking: true,
  ssr_telemetry_scp: true,
  ssr_telemetry_tatari: true,
  ssr_telemetry_tik_tok_pixel: true,
  ssr_telemetry_datalayer_pixel: true,
  ssr_telemetry_server_sgtm_pixel: true,
  ssr_telemetry_edge_tag: true,
  ssr_telemetry_stylitics: true,
  ssr_mixpanel_identify_by_customer_id: false,
  ssr_mixpanel_sdk_enabled: true, // true for US/CA, false for UK (set via Statsig per locale)
  ssr_ia_v2: true,
  ssr_csp_headers: false,
  ssr_i18n_us_rollout_gate: false,
  ssr_i18n_us_rollout_distribution: false,
  ssr_i18n_lang_dropdown_enabled: false,
  ssr_app_push_banner: true,
  ssr_use_ultra_lite: false,
  ssr_collection_feature_flag_fallback_implementation: true,
  ssr_site_data_experiment_enabled: true,
  'ssr-use-ultra-light-product-info-for-qsal': false,
  ssr_partial_review_stars: false,
  ssr_wishlist_use_sdk_http_client: false,
  ssr_reporting_services_use_sdk_http_client: false,
  'ssr-use-design-system-components': false,
  'seo-title-append-quince-locale': false,
  multi_pool_auth_enabled: false,
  ssr_fingerprinting: false,
  ssr_email_subscription: false,
  pdp_optimistic_option_selection: false, // INP: optimistic swatch/size highlight on PDP + product cards
} as const

export type UserAgnosticGlobalFeatureGatesFromStatsig = Record<keyof typeof FEATURE_GATE_REGISTRY, boolean>
export interface UserAgnosticGlobalFeatureGatesFromServerSideProps {
  isI18nPreviewEnabled: boolean
}
export type UserAgnosticGlobalFeatureGates = UserAgnosticGlobalFeatureGatesFromStatsig &
  UserAgnosticGlobalFeatureGatesFromServerSideProps

export const userAgnosticGlobalFeatureGatesDefaultsB2B: UserAgnosticGlobalFeatureGates = {
  ...FEATURE_GATE_REGISTRY,
  ssr_ia_v2: true,
  ssr_csp_headers: false,
  ssr_i18n_us_rollout_gate: false,
  ssr_i18n_us_rollout_distribution: false,
  ssr_i18n_lang_dropdown_enabled: false,
  ssr_app_push_banner: false,

  isI18nPreviewEnabled: false,
}

export const userAgnosticGlobalFeatureGatesDefaults: UserAgnosticGlobalFeatureGates = {
  ...FEATURE_GATE_REGISTRY,
  isI18nPreviewEnabled: true,
}

/**
 * Generate entries array from the registry
 * This is stored outside functions since it doesn't change
 */
export const featureGatesEntries = Object.entries(FEATURE_GATE_REGISTRY) as [
  keyof UserAgnosticGlobalFeatureGatesFromStatsig,
  boolean,
][]
